"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_2 = require("@osmosys/react");
exports.RecentContentFeedPushModal = ({ isOpen, close, }) => {
    return (react_1.default.createElement(react_2.OsmosysModal, { isOpen: isOpen, toggle: close },
        react_1.default.createElement(react_2.OsmosysModal.Header, { toggle: close }, "Recent content pushes")));
};
//# sourceMappingURL=RecentContentFeedPushModal.js.map